export const ItemTypes = {
  DRAGGABLE: 'Draggable',
};
